export default {"src":"/_next/static/media/lusd.1d09460e.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};